export const Logo = ({ dark = false }) => (
  <a href="#top" data-testid="brand-logo" className="flex items-center gap-2.5 shrink-0">
    <img
      src="/logo.png"
      alt="Little Serein logo"
      className="h-11 w-11 rounded-full shadow-[0_4px_14px_-4px_rgba(6,78,59,0.4)]"
    />
    <span
      className={`font-serif text-xl sm:text-2xl font-semibold tracking-tight ${
        dark ? "text-[#FDFBF7]" : "text-[#064E3B]"
      }`}
    >
      Little <span className="italic font-medium">Serein</span>
    </span>
  </a>
);
